import { EventEmitter, OnInit } from '@angular/core';
import { CandidateEntityModel } from 'app/interfaces';
import * as moment from 'moment';
var CandidateDetailComponent = /** @class */ (function () {
    function CandidateDetailComponent() {
        this.changeProcessStatus = new EventEmitter();
    }
    Object.defineProperty(CandidateDetailComponent.prototype, "years", {
        get: function () {
            return moment().diff(this.candidate.User.birth_date, 'years');
        },
        enumerable: true,
        configurable: true
    });
    CandidateDetailComponent.prototype.ngOnInit = function () {
    };
    CandidateDetailComponent.prototype.emitChangeProcessStatus = function (processStatus) {
        this.changeProcessStatus.emit(processStatus);
    };
    return CandidateDetailComponent;
}());
export { CandidateDetailComponent };
